export default {"src":"/_next/static/media/sparkle.83231b8f.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};